import { BOOST_CODE } from '@packages/types';

export const personalisationBoostAU = {
  title: {
    [BOOST_CODE.GADGET_COVER]: 'Planning to take your smartphone or laptop?',
    [BOOST_CODE.EXTRA_CANCELLATION]: 'Upgrade your extra cancellation?',
    [BOOST_CODE.SPECIFIED_ITEM]: 'Taking jewellery or medical devices? ',
    [BOOST_CODE.MOTORCYCLE]: 'Planning to ride a scooter or moped?',
    [BOOST_CODE.SNOW_SPORTS]: 'Planning on skiing or snowboarding?',
    [BOOST_CODE.RENTAL_COVER]: 'Planning on renting a vehicle?',
    [BOOST_CODE.ADVENTURE_ACTIVITIES]: 'Planning on trekking or skydiving?',
    [BOOST_CODE.CRUISE_COVER]: 'Planning on taking a cruise?',
  },
  description: 'Increase your level of coverage for your trip',
  action: {
    title: 'Continue',
  },
};
